import Vue from 'vue'
import { Popup, Toast, Notify, Sticky, Lazyload } from 'vant'
import '@vant/touch-emulator'

Vue.use(Popup)
Vue.use(Toast)
Vue.use(Notify)
Vue.use(Sticky)
Vue.use(Lazyload, {
  lazyComponent: true
})
